import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { stringifySafe } from 'screens/Admin/Accounts/components/syncSolicitudDocModalHelpers';

type SyncSolicitudDocInitialErrorModalProps = {
  show: boolean;
  response: any;
  onClose: () => void;
};

function SyncSolicitudDocInitialErrorModal( {
  show,
  response,
  onClose,
}: SyncSolicitudDocInitialErrorModalProps ) {
  const { t } = useTranslation();
  const msg = typeof response?.errors === 'string'
    ? response.errors
    : stringifySafe( response?.data ?? response ) || t( 'admin.account.syncSolicitudDocUnknownError' );

  return (
    <Modal show={show} centered onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>{t( 'admin.account.syncSolicitudDocInitialErrorTitle' )}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text--sm mb-0">{msg}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={onClose}>
          {t( 'close' )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default SyncSolicitudDocInitialErrorModal;
